import {
  defineConfig,
  mergeConfigs,
  SystemConfig,
} from "shared/components/Spor";

import { badgeRecipe } from "shared/theme/sidespor/recipes/badge";
import { buttonRecipe } from "shared/theme/sidespor/recipes/button";
import { dialogRecipe } from "shared/theme/sidespor/recipes/dialog";
import { tableRecipe } from "shared/theme/sidespor/recipes/table";
import { semanticTokens } from "shared/theme/sidespor/theme/semanticTokens";

/**
 * If you want to add more `recipes` to sidesporConfig then I recommend this:
 * - Go to https://github.com/nsbno/spor
 * - Find the component you want to make a recipe for (say input) and find the file `input.ts`
 * - Check if that file is inside the folder `slot-recipes` or `recipes`, and match that here
 * - Copy another `slot-recipe` or `recipe` here and modify it to for the new component instead.
 * - Optional: Update https://design.vy.no/spor/guides/sidespor at https://vydesignmanual.sanity.studio/production/structure
 */
const sidesporConfig = defineConfig({
  theme: {
    semanticTokens,
    recipes: {
      badge: badgeRecipe,
      button: buttonRecipe,
    },
    slotRecipes: {
      dialog: dialogRecipe,
      table: tableRecipe,
    },
  },
});

export const extendSidespor = (systemConfig: SystemConfig): SystemConfig =>
  mergeConfigs(systemConfig, sidesporConfig);
